import React, { useContext } from 'react';
import { Link, useNavigate} from 'react-router-dom';
import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faUser,
  faHome,
  faBell,
} from '@fortawesome/free-solid-svg-icons'
import Navbar from './Navbar';
import UserContext from '../hooks/UserContext';
import ConfigContext from '../hooks/ConfigContext'
import NotificationContext from '../hooks/NotificationContext';
import wishlistImg from '../images/wishlist.png'
import Avatar from './Avatar';

const appBarCss = css`
  background-color: #121921;
  color: white;
  font-weight: bold;
  height: 50px;
  border-bottom: 1px solid black;
  &.proxy {
    background-color: red;
  }
  .app-title {
    font-size: 1.1em;
    display: flex;
    flex-direction:column;
  }  
  .env {
    font-size: 0.75em;
  }
  .menu.proxy {
    font-weight: bold;
    font-size: larger;
    flex-grow: 1;
    justify-content: center;

    & button {
      font-size: 0.75em;
    }
  }
  .menu.right {
    //gap: 5px;
    .menu-item {
      padding-left: 0.5em;
      padding-right: 0.5em;
      font-size: 1.25em;
      &.notifications {
        position: relative;
        font-size: 1.75em;
        display: flex;
        gap: 5px;
        position: relative;
        & .count {
          position: absolute;
          top: -5px;
          left: 3px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: red;
          font-weight: bold;
          font-size: 0.55em;
          color: white;
          border-radius: 50%;
          height: 1.5em;
          width: 1.5em;
        }
      }
      & .avatar {
        height: 2.5em;
        width: 2.5em;
        padding: 0px;
      }
    }
  }
`;

const AppBar = styled(({ className }) => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const isProxy = user.isProxy;
  const { env } = useContext(ConfigContext);
  const { count: notificationCount } = useContext(NotificationContext);

  return (
    <Navbar className={`${className} ${isProxy ? 'proxy' : ''}`}>
      <div className='menu left'>
        <div className="menu-item logo">
          <img src={wishlistImg} alt='logo' />
          <div className='app-title'>
            <span>Groupster</span>
            {env !== 'production' && <div className='env'>{env}</div>}
          </div>
        </div>
      </div>
      {
        isProxy && 
        <div className='menu proxy'>
          {`${user.firstname} ${user.lastname}`}
          <button className = 'primary' onClick={() => navigate('/login')}>Logout</button>
        </div>
      }

      <div className="menu right">
        {
          user?.isAdmin &&
          <Link className='menu-item' to='/users'>
            <FontAwesomeIcon icon={faUser} />
          </Link>
        }
        {user &&
          <>
            <Link className='menu-item' to='/dashboard'>
              <FontAwesomeIcon icon={faHome} />
            </Link>
            <Link className='menu-item notifications' to='/notifications'>
              <FontAwesomeIcon icon={faBell} />
              {
                notificationCount
                  ?
                  <div className='count'>
                    <span>{notificationCount}</span>
                  </div>
                  : null
              }
            </Link>
            <Link className='menu-item' to='/account'>
              <Avatar className='avatar' width={50} src={user.avatar} title={`${user.firstname} ${user.lastname}`} />
            </Link>
          </>
        }
      </div>
    </Navbar>
  )
})`${appBarCss}`;

export default AppBar;
